import { Inject } from '@odinjs/odin';

import { AutocompleteAPI, FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnChange, OnMount } from '@philips-emr/tws-core/lib/client';
import { ChangeEvent, FetchEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

interface Produto {
  nrSeqPlano: number;
  nmPlano: string;
  dsTipoContratacao: string;
}

@Controller({ fragment: 'tabela-preco' })
export default class TabelaPrecoController extends BaseController {

  private firstFetch: boolean = true;

  @Inject('fetch-tabela-preco')
  tabelaPrecoFetchAPI: FetchAPI;

  @Inject('autocomplete-tabela-preco-produto')
  autocompleteApiProduto: AutocompleteAPI;

  @OnMount({ target: 'layout-tabela-preco' })
  onMountLayoutTabelaPreco(): void {
    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqContrato });
    this.firstFetch = true;
  }

  @OnAfterFetch({ target: 'fetch-filter-produtos' })
  onAfterFetchFilterProducts(event: FetchEvent): void {
    if(!event.data) {
      return;
    }
    const products = (event.data as Produto[]);

    if (this.firstFetch && products && products.length) {
      const product = products[0];
      this.context.set({ nrSeqPlano: product.nrSeqPlano });
      this.autocompleteApiProduto.setValue({ nmPlano: product.nmPlano, nrSeqPlano: product.nrSeqPlano });
      this.fetchTabelaPrecos(product);
      this.firstFetch = false;
    }
  }

  private fetchTabelaPrecos(product: Produto): void {
    this.tabelaPrecoFetchAPI.setParameters({ ...this.tabelaPrecoFetchAPI.getParameters(), nrSeqPlano: product.nrSeqPlano });
    this.tabelaPrecoFetchAPI.forceFetch();
  }

  @OnChange({ target: 'autocomplete-tabela-preco-produto' })
  onChangeAutocompleteProduct(event: ChangeEvent<Produto>): void {
    const product = event.value;

    if (product && product.nrSeqPlano) {
      this.fetchTabelaPrecos(product);
    }
  }

}

